import { render, staticRenderFns } from "./ProductButtonDownloadSample.vue?vue&type=template&id=4efcc6ae&"
import script from "./ProductButtonDownloadSample.vue?vue&type=script&lang=js&"
export * from "./ProductButtonDownloadSample.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports